var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXboxOneL2Button(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80518 28V17.0909H10.1116V26.0984H14.7885V28H7.80518ZM15.5131 18.9925V17.0909H24.4727V18.9925H21.1328V28H18.853V18.9925H15.5131Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77734 3.23041H19.9707L24.4619 13.331L24.5469 13.5234L24.7148 13.6503L36.0098 22.1982C36.7498 22.7582 37.1846 23.6334 37.1846 24.5615V32.2226C37.1844 33.8586 35.8586 35.1853 34.2227 35.1855H6.77734C5.14137 35.1853 3.81563 33.8586 3.81543 32.2226V6.19232C3.81566 4.55637 5.14139 3.23064 6.77734 3.23041Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXboxOneL2Button);
export default __webpack_public_path__ + "static/media/XBOXOne-L2Button.1809e5f933e2be9c143681e8608e4246.svg";
export { ForwardRef as ReactComponent };